import { RocketLaunchIcon, TrendUpIcon, WarningIcon, TrendDownIcon, ClockIcon } from "@phosphor-icons/react";

const price = (p) => {
  if (p == null) return "—";
  if (p >= 1) return `$${p.toLocaleString(undefined, { maximumFractionDigits: 4 })}`;
  return `$${p.toPrecision(3)}`;
};
const clock = (t) => (t ? new Date(t * 1000).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
const pct = (v) => (v == null ? "" : `${v > 0 ? "+" : ""}${v}%`);

export default function RugTimeline({ timeline, symbol }) {
  if (!timeline) return null;
  const { start, peak, turn, trough, current, drawdownFromPeakPct, runupToPeakPct, peakToTurnMin } = timeline;
  const rows = [
    { icon: RocketLaunchIcon, color: "text-white", label: "Launch window", ts: start?.t, price: start?.price, note: null },
    { icon: TrendUpIcon, color: "text-neon", label: "Peak", ts: peak?.t, price: peak?.price, note: runupToPeakPct != null ? `${pct(runupToPeakPct)} run-up` : null },
    turn && { icon: WarningIcon, color: "text-red-400", label: "The turn", ts: turn?.t, price: turn?.to, note: `${pct(turn?.dropPct)} candle${peakToTurnMin != null ? ` · ${peakToTurnMin}m after peak` : ""}`, highlight: true },
    { icon: TrendDownIcon, color: "text-red-300", label: "Trough", ts: trough?.t, price: trough?.price, note: null },
    { icon: ClockIcon, color: "text-muted-foreground", label: "Now", ts: current?.t, price: current?.price, note: drawdownFromPeakPct != null ? `${pct(drawdownFromPeakPct)} from peak` : null },
  ].filter(Boolean);

  return (
    <div className="border border-white/10 bg-black/30 p-4 mt-4" data-testid="rug-timeline">
      <div className="flex items-center gap-2 mb-3">
        <WarningIcon size={16} weight="fill" className="text-red-400" />
        <h4 className="font-heading font-bold text-sm tracking-tight">Here's the minute it turned{symbol ? ` · $${String(symbol).toUpperCase()}` : ""}</h4>
      </div>
      <div className="relative pl-4">
        <div className="absolute left-[6px] top-1 bottom-1 w-px bg-white/10" />
        {rows.map((r, i) => {
          const Icon = r.icon;
          return (
            <div key={i} className={`relative flex items-start gap-3 py-1.5 ${r.highlight ? "" : ""}`} data-testid={`timeline-row-${i}`}>
              <span className={`absolute -left-4 mt-0.5 ${r.color}`}><Icon size={13} weight="fill" /></span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span className={`text-xs font-semibold ${r.highlight ? "text-red-300" : "text-white"}`}>{r.label}</span>
                  <span className="font-mono text-xs text-muted-foreground">{clock(r.ts)}</span>
                </div>
                <div className="flex items-center gap-2 text-[11px]">
                  <span className="font-mono text-white/80">{price(r.price)}</span>
                  {r.note && <span className={r.highlight ? "text-red-400" : "text-muted-foreground"}>· {r.note}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
